module.exports = "/fast-coin/img/coin/anim/out_2/out_2_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_001.png
// module id = 2307
// module chunks = 5